import { type WorkspaceAgentComposerSelectionDragItem } from '~/components/v2/components/workspace/workspace-agent-panel/drag/workspaceAgentComposerSelectionDragPayload';

const authorizationKeyForDragItem = (item: WorkspaceAgentComposerSelectionDragItem): string =>
  item.kind === 'asset' ? `asset:${item.assetId}:${item.versionId}` : `board:${item.boardId}`;

let workspaceAgentComposerSelectionDragPreviewLabel: string | null = null;
let isWorkspaceAgentComposerSelectionDragActive = false;
let workspaceAgentComposerSelectionDragSessionId = 0;
let workspaceAgentComposerSelectionDragAuthorizedItemKeys = new Set<string>();

export const beginWorkspaceAgentComposerSelectionDrag = (previewLabel: string | null): void => {
  workspaceAgentComposerSelectionDragSessionId += 1;
  workspaceAgentComposerSelectionDragPreviewLabel = previewLabel;
  isWorkspaceAgentComposerSelectionDragActive = true;
  workspaceAgentComposerSelectionDragAuthorizedItemKeys = new Set();
};

export const setWorkspaceAgentComposerSelectionDragAuthorizedItems = (
  items: readonly WorkspaceAgentComposerSelectionDragItem[],
): void => {
  workspaceAgentComposerSelectionDragAuthorizedItemKeys = new Set(items.map(authorizationKeyForDragItem));
};

export const getWorkspaceAgentComposerSelectionDragAuthorizedItemKeys = (): ReadonlySet<string> =>
  workspaceAgentComposerSelectionDragAuthorizedItemKeys;

export const getWorkspaceAgentComposerSelectionDragSessionId = (): number =>
  workspaceAgentComposerSelectionDragSessionId;

export const endWorkspaceAgentComposerSelectionDrag = (): void => {
  workspaceAgentComposerSelectionDragPreviewLabel = null;
  isWorkspaceAgentComposerSelectionDragActive = false;
  workspaceAgentComposerSelectionDragAuthorizedItemKeys = new Set();
};

export const isWorkspaceAgentComposerSelectionDragSessionActive = (): boolean =>
  isWorkspaceAgentComposerSelectionDragActive;

export const getWorkspaceAgentComposerSelectionDragPreviewLabel = (): string | null =>
  workspaceAgentComposerSelectionDragPreviewLabel;
